module.exports = __webpack_public_path__ + "img/LT.1e3c7360.png";